import type { HiredEquipmentEntryMethod } from '../types';

export interface AnchorFieldValues {
  vendorId?: number | null;
  poId?: number | null;
  taskId?: number | null;
}

/**
 * Gates "Continue to grid". Service area is never required.
 *
 * When `poEnabled` is false, PO mode still requires a vendor but must not block
 * on a missing PO (HE-P04 graceful degradation → manual line entry).
 */
export function canContinueToGrid(
  entryMethod: HiredEquipmentEntryMethod,
  values: AnchorFieldValues,
  poEnabled: boolean,
): boolean {
  switch (entryMethod) {
    case 'purchase_order': {
      if (!values.vendorId) return false;
      if (poEnabled && !values.poId) return false;
      return true;
    }
    case 'subcontractor':
      return Boolean(values.vendorId);
    case 'task':
      return Boolean(values.taskId);
    default:
      return false;
  }
}

export function defaultEntryMethod(poEnabled: boolean): HiredEquipmentEntryMethod {
  return poEnabled ? 'purchase_order' : 'subcontractor';
}
